/**
 * File size threshold (bytes) below which full-resolution image previews are fetched
 * automatically when the preview carousel opens. Larger images require explicit opt-in.
 */
export const IMAGE_PREVIEW_FULL_AUTO_MAX_BYTES = 20 * 1024 * 1024;

/**
 * Marks a `FileIcon` thumbnail so the files preview group can open that slide via DOM click
 * (same path as a direct thumbnail click — required by `@rc-component/image` `keepOpenIndex`).
 */
export const FILES_IMAGE_PREVIEW_FILE_ID_ATTR = 'data-files-preview-file-id';
